// extracted by mini-css-extract-plugin
export default {"container":"RiskTaskModal_container__oSaYk"};